const popUpWidth = 483;
const popUpHeight = 600;

/**
 * Creates a popup window with the given url. Returns the window object for the popup.
 * @param popUpUrl Url for popup window.
 * @param _window Window object
 */
export function createPopupDialog(popUpUrl: string, _window: Window): Window {

    /**
    * Copied from WebAuthJS -> Adal-Msa.js
    * adding winLeft and winTop to account for dual monitor
    */
    const winLeft = _window.screenX;
    const winTop = _window.screenY;
    /**
    * window.innerWidth displays browser window's height and width excluding toolbars
    */
    const width = _window.innerWidth;
    const height = _window.innerHeight;
    const left = ((width / 2) - (popUpWidth / 2)) + winLeft;
    const top = ((height / 2) - (popUpHeight / 2)) + winTop;

    return _window.open(popUpUrl, 'login_window', `width=${popUpWidth},height=${popUpHeight},top=${top},left=${left}`);
}

/**
 * Creates a listener that checks if the given popup window was closed.
 * @param popupWindow Popup window object
 * @param _window parent window object
 * @param closeHandler callback for when popup is closed. window listener will be cleared before callback is called.
 * @returns ID for window setInterval handler. Cancel the handler by calling window.clearInterval()
 */
export function listenForPopupClose(popupWindow: Window, _window: Window, closeHandler: () => void): number {

    const popUpCloseListenerIntervalId = _window.setInterval(() => {
        if (!popupWindow || popupWindow.closed || popupWindow.closed === undefined) {
            _window.clearInterval(popUpCloseListenerIntervalId);
            closeHandler();
        }
    }, 100);

    return popUpCloseListenerIntervalId;
}
